import type { PTableColumn } from "../../components/PTable/PTable"

import { strings } from "../../config/strings"

export const numberOfRowsOptions = [10, 20, 50]

export const predictionJobsColumns: PTableColumn[] = [
    {name: 'name', headerName: strings.name, sortable: true, width: 25},
    {name: 'state', headerName: strings.state, sortable: true, width: 5},
    {name: 'creation_date', headerName: strings.creation_date, sortable: true, width: 10},   
    {name: 'actions', headerName: strings.actions, sortable:false, width: 5, align: 'right'},   
]
